import React from 'react'
import { Link } from 'react-router-dom'
import { findWhere } from 'underscore'
import ReactGA from 'react-ga';

import timestamps from '~/services/timestamps'
import { Icon } from '~/components'
import TextEdit from '~/services/textedit'


export default class extends React.Component {
    render() {

		return (
			<div className="vertical-article-holder">
				<div className="fill-image">
					<div className="background-fill clickable main-box breathe">
						<div className="flickering-logo">
							<object data="/img/logo.svg" type="image/svg+xml"></object>
						</div>
					</div>
				</div>
            	<footer className="p10 narrow-gutter">
            		<div className="row">
	            		<div className="col-xs-9">
	            			<div className="full-title breathe"></div>
	            			<div className="sub-title breathe"></div>
            			</div>
	            		<div className="col-xs-3">
	            			<div className="mleft20 mright20 mbot10">
		            			<div className="profile-image breathe"></div>
							</div>
            			</div>
            			<div className="clearfix"></div>
            		</div>
            	</footer>
			</div>
		)
		
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Discover/scenes/Unfiltered/components/FeaturedLatestLoading.jsx